export default __webpack_public_path__ + "static/media/allow-button.12e4836f.svg";